/***
 *                                       _           _____
 *                                      | |         |  ___|
 *      __ _  __ _  ___ _ __   ___ ___  | |__   ___ |___ \
 *     / _` |/ _` |/ _ \ '_ \ / __/ _ \ | '_ \ / _ \    \ \
 *    | (_| | (_| |  __/ | | | (_|  __/ | | | | (_) /\__/ /
 *     \__,_|\__, |\___|_| |_|\___\___| |_| |_|\___/\____/
 *            __/ |
 *           |___/
 *
 *           >> https://agenceho5.com
 */

import React, { Fragment } from 'react';
import { TableCell, Tooltip } from "@material-ui/core";




export const AlertsTable = {
  'ref': {
    head: <TableCell align='left'>#</TableCell>,
    row: (row) => <TableCell align='left'>{row.id}</TableCell>
  },
  'notifications': {
    head: <TableCell align='left'>Notificatications</TableCell>,
    row: (row) => <TableCell align='left'>{row.notifications.join(', ')}</TableCell>
  },
  'email': {
    head: <TableCell align='left'>Email</TableCell>,
    row: (row) => <TableCell align='left'>{row.email}</TableCell>
  },
  'categories': {
    head: <TableCell align='left'>Catégories</TableCell>,
    row: (row) => <TableCell align='left'>{row.allCategories ? <i>Toutes</i> : row.categories?.map(c => c.name)?.join(', ')}</TableCell>
  },
  'entities': {
    head: <TableCell align='left'>Entités</TableCell>,
    row: (row) => <TableCell align='left'>{row.allEntities ? <i>Toutes</i> : row.entities?.map(c => c.name)?.join(', ')}</TableCell>
  },
  'date': {
    head: <TableCell align='left'>Mise à jour</TableCell>,
    row: (row) => <TableCell align='left'><Tooltip title={<Fragment>Création : {(new Date(row.created)).toLocaleString()}<br />Mise à jour : {(new Date(row.updated)).toLocaleString()}</Fragment>}><abbr>{(new Date(row.updated)).toLocaleDateString()}</abbr></Tooltip></TableCell>
  }
}